@if(isSelectedeDetails){
<p-drawer styleClass="u ui-sidebar-lg" 
  [style]="isSampleRecord ? {'width':'auto','max-width': '520px','height':'auto','overflow-y': 'auto','max-height':'100%'} : {'width':'auto','max-width': '715px','height':'auto','overflow-y': 'auto','overflow-x': 'hidden !important','max-height':'100%'}"
[(visible)]="View" (onHide)="closeDialogBox()"
    position="right" [baseZIndex]="10000" id="compReviewViewSidebar">
    <ng-template pTemplate="header">
        <span class="report_side-by-side align-items-center" [ngClass]="{'sample_side-by-side':isSampleRecord}">Side-by-Side Comparison</span>
    </ng-template>
    <div class="ui-grid-col-12">
        <div [class]="isSampleRecord?'ui-grid-col-6 quick-view-grid-row-hg':'ui-grid-col-4 quick-view-grid-row-hg'">
         <input [disabled]="true" pInputText [(ngModel)]="fieldsName" class="fixed"/>
        </div>
        <div [class]="isSampleRecord?'ui-grid-col-6 quick-view-grid-row-hg':'ui-grid-col-4 quick-view-grid-row-hg'">
            <input [disabled]="true" pInputText [(ngModel)]="catHeader" class="inputClass field-header"/>
        </div>
         @if(!isSampleRecord){
        <div class="ui-grid-col-4 quick-view-grid-row-hg">
            <input [disabled]="true" pInputText [(ngModel)]="clientHeader" class="inputClassTwo field-header"/>

        </div>}
    </div>
    <div class="ui-grid-col-12">
        @for (viewRow of SelectedRowData; track viewRow; let idx = $index){
        <div [class]="isSampleRecord?'ui-grid-col-6 quick-view-grid-row-hg':'ui-grid-col-4 quick-view-grid-row-hg'">
            <label for="ui_Field_Name">{{viewRow?.fieldName}}</label>
        </div>
        @if(viewRow.catValue.indexOf("Leg Details")>=0){
            <div [class]="isSampleRecord?'ui-grid-col-6 quick-view-grid-row-hg':'ui-grid-col-4 quick-view-grid-row-hg'">
                <input [disabled]="true" pInputText [(ngModel)]="viewRow.catValue" class="inputClass innerjson-header"/>
            </div>
             @if(!isSampleRecord){
            <div class="ui-grid-col-4 quick-view-grid-row-hg">
                <div class="ui-grid-col-4 quick-view-grid-row-hg">
                    <input [disabled]="true" pInputText [(ngModel)]="viewRow.clientValue" class="inputClassTwo innerjson-header"/>
        
                </div>            </div>}

        }
        
        @if(viewRow.catValue.indexOf("Leg Details")<0) {
            <div [class]="isSampleRecord?'ui-grid-col-6 quick-view-grid-row-hg':'ui-grid-col-4 quick-view-grid-row-hg'">
                <input [disabled]="true" pInputText [(ngModel)]="viewRow.catValue" class="inputClass"
                    [ngClass]="{'input-mismatch': !viewRow?.valid && !constantService.matchStringsWithoutSpecialChars(viewRow?.fieldName,viewRow?.catValue,viewRow?.clientValue) && !isSampleRecord && idx!=0}" />
            </div>
             @if(!isSampleRecord){
            <div class="ui-grid-col-4 quick-view-grid-row-hg">
                <input [disabled]="true" pInputText [(ngModel)]="viewRow.clientValue" class="inputClassTwo"
                    [ngClass]="{'input-mismatch': !viewRow?.valid && !constantService.matchStringsWithoutSpecialChars(viewRow?.fieldName,viewRow?.catValue,viewRow?.clientValue) && idx!=0}" />
            </div>}
        }
        
    }
    </div>
</p-drawer>}